import type { AuthScheme } from 'api';

import { useWebhooks } from '../../hooks/useWebhooks';

export const useAffectedWebhooks = (scheme: AuthScheme) => {
  const { webhooks, isLoading, isError } = useWebhooks();
  const affected = isError
    ? []
    : webhooks.filter(
        (webhook) => webhook.active && webhook.auth_uuid === scheme.uuid
      );

  return { affected, isLoading, isError };
};
